module.exports = __webpack_public_path__ + "img/about-us.344b9d28.jpg";